import React from "react";
import Dropdown from "react-bootstrap/Dropdown";

const QuotationRevisionActions = ({
  onSaveDraft,
  onComplete,
  disabled = false,
}) => (
  <Dropdown className="quote-revision-dropdown">
    <Dropdown.Toggle
      className="btn quote-revision-actions"
      type="button"
      disabled={disabled}
    >
      Revision Actions <i className="fas fa-chevron-down ml-2" aria-hidden="true" />
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item
        className="quote-revision-dropdown-item"
        onClick={onSaveDraft}
        disabled={disabled}
      >
        <i className="fas fa-save" aria-hidden="true" />
        Save Draft
      </Dropdown.Item>
      <Dropdown.Item
        className="quote-revision-dropdown-item"
        onClick={onComplete}
        disabled={disabled}
      >
        <i className="fas fa-check-circle" aria-hidden="true" />
        Revision Complete
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
);

export default React.memo(QuotationRevisionActions);
